export default __webpack_public_path__ + "static/media/photo_5282747746622312893_y.0c5cb998.jpg";